import { Outlet } from "react-router";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import { useEffect } from "react";

const User = ({ subRoutes }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (
      !subRoutes.find((route) => route.isVisible) &&
      window.location.pathname === "/user"
    ) {
      navigate("/user/list");
    }
  }, []);

  return (
    <div className="h-screen min-h-full max-h-full dark:bg-gray-900 bg-gray-200 overflow-auto ">
      <Layout>
        <Outlet />
      </Layout>
    </div>
  );
};

export default User;
